import { QUERY_DEFAULTS } from '@/shared/lib/constants';
import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { getConnectorTypeSchemaApi } from '@/entities/connector/api';
import type { ConnectorTypeSchema } from '@/entities/connector/types';

type UseConnectorTypeSchemaParams = {
  type: string;
  enabled?: boolean;
};

export const useConnectorTypeSchema = ({ type, enabled = true }: UseConnectorTypeSchemaParams) => {
  return useQueryWithBoundary<ConnectorTypeSchema>({
    ...DEFAULT_QUERY_OPTIONS,
    queryKey: connectorKeys.typeSchema(type),
    queryFn: () => getConnectorTypeSchemaApi(type),
    enabled: enabled && !!type,
    staleTime: QUERY_DEFAULTS.STALE_TIME.MEDIUM,
    gcTime: QUERY_DEFAULTS.GC_TIME.MEDIUM,
  });
};
